import FormControl from 'global/form/FormControl';

class ReviewStepFormControl extends FormControl {
	static initTermsAndConditionsCheckboxValidationEvent() {
		const termsAndConditionsCheckbox =
			document.getElementById('termsAndConditions');
		if (termsAndConditionsCheckbox) {
			termsAndConditionsCheckbox.dataset.validationEvent = 'change';
		}
	}

	submitActions(e) {
		if (!this.isFormValid()) {
			e.preventDefault();
		} else {
			const submitBtn = document.getElementById('orderReviewSubmit');
			submitBtn.disabled = true;
			submitBtn.classList.add('btn--is-waiting');
		}
	}

	onSubmit(e) {
		const purchaseOrderForm = document.getElementById('purchaseOrderForm');

		if (purchaseOrderForm) {
			const addPurchaseOrderBtn = document.getElementById(
				'addOrderReferenceBtn',
			);
			const purchaseOrderInput = document.getElementById('purchaseOrder');
			const purchaseOrderFormControl = new FormControl(purchaseOrderForm);

			const isPurchaseOrderValid = purchaseOrderFormControl.onSubmit(e);
			const isPurchaseOrderMandatory =
				purchaseOrderInput.getAttribute('data-override') !== 'required';

			if (isPurchaseOrderValid && !isPurchaseOrderMandatory) {
				this.submitActions(e);
			} else if (isPurchaseOrderValid && isPurchaseOrderMandatory) {
				e.preventDefault();
				addPurchaseOrderBtn.classList.add('is-error');
			}
		} else {
			this.submitActions(e);
		}
	}
}

export default ReviewStepFormControl;
